module.exports = __webpack_public_path__ + "static/lion-logo-85b754dc2a243eff1b15601a7b1b8565.png";